module.exports = __webpack_public_path__ + "static/media/028-toothbrushes.79e05ffa.svg";